import React from "react";
import { getLevelGradient } from "./../../../helper/xpHelpers.js";

/**
 * LevelBadge — emblema circular do level atual.
 * Props: level, name, icon, size (px)
 */
class LevelBadge extends React.Component {
  render() {
    var size = this.props.size || 48;
    var level = this.props.level || 1;
    var name = this.props.name;
    var icon = this.props.icon || 'fas fa-medal';
    var gradient = getLevelGradient(level);

    return (
      <div
        title={name || ('Nível ' + level)}
        style={{
          width: size + 'px',
          height: size + 'px',
          background: gradient,
          borderRadius: '50%',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: (size * 0.45) + 'px',
          boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
          position: 'relative'
        }}
      >
        <i className={icon} />
        {level > 0 && (
          <span style={{
            position: 'absolute',
            bottom: '-2px',
            right: '-2px',
            backgroundColor: '#fff',
            color: '#333',
            borderRadius: '50%',
            width: size * 0.4 + 'px',
            height: size * 0.4 + 'px',
            fontSize: size * 0.22 + 'px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 700,
            border: '2px solid #fff',
            boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
          }}>
            {level}
          </span>
        )}
      </div>
    );
  }
}

export default LevelBadge;
